import { render, staticRenderFns } from "./TypeCard.vue?vue&type=template&id=43b76ad6&scoped=true&"
import script from "./TypeCard.vue?vue&type=script&lang=js&"
export * from "./TypeCard.vue?vue&type=script&lang=js&"
import style0 from "./TypeCard.vue?vue&type=style&index=0&id=43b76ad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b76ad6",
  null
  
)

export default component.exports